import React, { useEffect } from "react";
import "../../App.css";
import CardItem from "../CardItem";
import "../Cards.css";

export default function EscapingMediocrity() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div
        className="blog-head-container"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1452421822248-d4c2b47f0c81?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=967&q=80)",
        }}
      >
        {/* <video src="assets/videos/video-1.mp4" autoPlay loop muted /> */}
        <h1>Escaping Mediocrity</h1>
        <p>
          In these blog posts I tell the story of how I left the path to
          mediocrity and made myself independent.
        </p>
      </div>
      <div className="cards__container">
        <div className="cards__wrapper">
          <ul className="cards__items">
            <CardItem
              src="https://images.unsplash.com/photo-1570633041664-49534b849107?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
              title="A Balanced Life"
              label=""
              path="/a-balanced-life"
              subtitle="fulfillment, mindset"
            />
            <CardItem
              src="https://images.unsplash.com/photo-1598301257982-0cf014dabbcd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
              title="How To Find Book Recommendations"
              label=""
              path="/book-recommendations"
              subtitle="books"
            />
          </ul>
          <ul className="cards__items">
            <CardItem
              src="https://images.unsplash.com/photo-1445821185708-62c36d070323?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1353&q=80"
              title="A guide of defining one’s goal in life"
              label=""
              path="/defining-goal"
              subtitle="direction, goal"
            />
          </ul>
        </div>
      </div>
    </>
  );
}
